import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    id: "alert-dialog",
    class: "alert-dialog"
};
const _hoisted_2 = { method: "dialog" };
const _hoisted_3 = {
    id: "alert-dialog-title",
    class: "title"
};
const _hoisted_4 = {
    key: 0,
    class: "classic-mode-switch"
};
const _hoisted_5 = {
    key: 0,
    class: "wrybit-boot",
    role: "status",
    "aria-live": "polite"
};
const _hoisted_6 = { class: "notice" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_WrybitBoundary = _resolveComponent("WrybitBoundary");
    const _component_CreateGameForm = _resolveComponent("CreateGameForm");
    const _component_GameHome = _resolveComponent("GameHome");
    const _component_ReplayHome = _resolveComponent("ReplayHome");
    const _component_CardMaker = _resolveComponent("CardMaker");
    const _component_CardLibrary = _resolveComponent("CardLibrary");
    const _component_MapEditor = _resolveComponent("MapEditor");
    const _component_MapLibrary = _resolveComponent("MapLibrary");
    const _component_WaitingFor = _resolveComponent("WaitingFor");
    const _component_InputPortal = _resolveComponent("InputPortal");
    const _directive_i18n = _resolveDirective("i18n");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['topmost-' + _ctx.screen, { 'wrybit-ui': _ctx.wrybitMode && _ctx.wrybitReady }])
    }, [
        _createElementVNode("section", null, [
            _createElementVNode("dialog", _hoisted_1, [
                _createElementVNode("form", _hoisted_2, [
                    _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_3, [...(_cache[3] || (_cache[3] = [
                            _createTextVNode("Error with input", -1)
                        ]))])), [
                        [_directive_i18n]
                    ]),
                    _cache[4] || (_cache[4] = _createElementVNode("p", { id: "alert-dialog-message" }, null, -1)),
                    _cache[5] || (_cache[5] = _createElementVNode("menu", { class: "dialog-menu centered-content" }, [
                        _createElementVNode("button", {
                            id: "alert-dialog-button",
                            class: "btn btn-lg btn-primary"
                        }, "OK")
                    ], -1))
                ])
            ])
        ]),
        _createVNode(_component_WrybitBoundary, {
            enabled: _ctx.wrybitMode,
            screen: _ctx.screen,
            onClassic: _ctx.useClassicInterface,
            onActive: _cache[0] || (_cache[0] = ($event) => (_ctx.wrybitReady = $event)),
            onViews: _cache[1] || (_cache[1] = ($event) => (_ctx.wrybitViews = $event))
        }, null, 8, ["enabled", "screen", "onClassic"]),
        (!_ctx.wrybitMode && _ctx.screen !== 'cards')
            ? (_openBlock(), _createElementBlock("aside", _hoisted_4, [
                _withDirectives((_openBlock(), _createElementBlock("button", {
                    type: "button",
                    class: "btn",
                    "data-test": "wrybit-layout",
                    onClick: _cache[2] || (_cache[2] =
                        //@ts-ignore
                        (...args) => (_ctx.useWrybitInterface && _ctx.useWrybitInterface(...args)))
                }, [...(_cache[6] || (_cache[6] = [
                        _createTextVNode("Wrybit layout", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", {
            class: _normalizeClass(["main-container", { 'wrybit-booting': _ctx.wrybitMode && !_ctx.wrybitReady }])
        }, [
            (_ctx.wrybitMode && !_ctx.wrybitReady)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[7] || (_cache[7] = [
                        _createElementVNode("div", { class: "wrybit-boot__spinner" }, null, -1)
                    ]))]))
                : _createCommentVNode("", true),
            (_ctx.screen === 'start-screen')
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.wrybitMode && _ctx.wrybitReady && _ctx.wrybitViews.startScreen ? _ctx.wrybitViews.startScreen : 'StartScreen'), { key: 1 }))
                : (_ctx.screen === 'create-game-form')
                    ? (_openBlock(), _createBlock(_component_CreateGameForm, { key: 2 }))
                    : (_ctx.screen === 'load')
                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.wrybitMode && _ctx.wrybitReady && _ctx.wrybitViews.loadGame ? _ctx.wrybitViews.loadGame : 'LoadGameForm'), { key: 3 }))
                        : (_ctx.screen === 'game-home' && _ctx.game !== undefined)
                            ? (_openBlock(), _createBlock(_component_GameHome, {
                                key: 4,
                                game: _ctx.game
                            }, null, 8, ["game"]))
                            : (_ctx.screen === 'player-home' && _ctx.playerView !== undefined)
                                ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.wrybitMode && _ctx.wrybitReady && _ctx.wrybitViews.playerHome ? _ctx.wrybitViews.playerHome : 'PlayerHome'), {
                                    "player-view": _ctx.playerView,
                                    key: _ctx.playerkey
                                }, null, 8, ["player-view"]))
                                : (_ctx.screen === 'spectator-home' && _ctx.spectator !== undefined)
                                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.wrybitMode && _ctx.wrybitReady && _ctx.wrybitViews.spectatorHome ? _ctx.wrybitViews.spectatorHome : 'SpectatorHome'), {
                                        spectator: _ctx.spectator,
                                        key: _ctx.spectator.id
                                    }, null, 8, ["spectator"]))
                                    : (_ctx.screen === 'the-end' && _ctx.participant !== undefined)
                                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.wrybitMode && _ctx.wrybitReady && _ctx.wrybitViews.gameEnd ? _ctx.wrybitViews.gameEnd : 'GameEnd'), {
                                            key: 7,
                                            participant: _ctx.participant
                                        }, null, 8, ["participant"]))
                                        : (_ctx.screen === 'replay')
                                            ? (_openBlock(), _createBlock(_component_ReplayHome, { key: 8 }))
                                            : (_ctx.screen === 'games-overview')
                                                ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.wrybitMode && _ctx.wrybitReady && _ctx.wrybitViews.gamesOverview ? _ctx.wrybitViews.gamesOverview : 'GamesOverview'), { key: 9 }))
                                                : (_ctx.screen === 'cards')
                                                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.wrybitMode && _ctx.wrybitReady && _ctx.wrybitViews.cards ? _ctx.wrybitViews.cards : 'CardList'), { key: 10 }))
                                                    : (_ctx.screen === 'card-maker')
                                                        ? (_openBlock(), _createBlock(_component_CardMaker, { key: 11 }))
                                                        : (_ctx.screen === 'card-library')
                                                            ? (_openBlock(), _createBlock(_component_CardLibrary, { key: 12 }))
                                                            : (_ctx.screen === 'map-editor')
                                                                ? (_openBlock(), _createBlock(_component_MapEditor, { key: 13 }))
                                                                : (_ctx.screen === 'map-library')
                                                                    ? (_openBlock(), _createBlock(_component_MapLibrary, { key: 14 }))
                                                                    : (_ctx.screen === 'admin')
                                                                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.wrybitMode && _ctx.wrybitReady && _ctx.wrybitViews.adminHome ? _ctx.wrybitViews.adminHome : 'AdminHome'), { key: 15 }))
                                                                        : (_ctx.screen === 'login-home')
                                                                            ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.wrybitMode && _ctx.wrybitReady && _ctx.wrybitViews.loginHome ? _ctx.wrybitViews.loginHome : 'LoginHome'), { key: 16 }))
                                                                            : (_ctx.screen === 'help')
                                                                                ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.wrybitMode && _ctx.wrybitReady && _ctx.wrybitViews.help ? _ctx.wrybitViews.help : 'Help'), { key: 17 }))
                                                                                : (_ctx.screen === 'stats')
                                                                                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.wrybitViews.stats ?? 'StartScreen'), { key: 18 }))
                                                                                    : _createCommentVNode("", true)
        ], 2),
        (_ctx.screen === 'player-home' && _ctx.playerView !== undefined && _ctx.playerView.game.phase !== 'end')
            ? (_openBlock(), _createBlock(_component_InputPortal, {
                key: 1,
                target: _ctx.inputHosts.target.value
            }, {
                default: _withCtx(() => [
                    (_openBlock(), _createBlock(_component_WaitingFor, {
                        key: _ctx.inputRevision,
                        "player-view": _ctx.playerView,
                        waitingfor: _ctx.playerView.waitingFor
                    }, null, 8, ["player-view", "waitingfor"]))
                ]),
                _: 1
            }, 8, ["target"]))
            : _createCommentVNode("", true),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[8] || (_cache[8] = [
                _createTextVNode(" Not affiliated with FryxGames, Asmodee Digital or Steam in any way. ", -1)
            ]))])), [
            [_directive_i18n]
        ])
    ], 2));
}
